import { motion } from "framer-motion";
import { Leaf, TrendingDown, ShieldCheck, Sparkles, Zap } from "lucide-react";
import { useLanguage } from "@/contexts/language-context";

export function Features() {
  const { t } = useLanguage();

  const features = [
    {
      icon: Leaf,
      title: t("features.green.title"),
      description: t("features.green.description"),
    },
    {
      icon: TrendingDown,
      title: t("features.cost.title"),
      description: t("features.cost.description"),
    },
    {
      icon: ShieldCheck,
      title: t("features.safe.title"),
      description: t("features.safe.description"),
    },
    {
      icon: Sparkles,
      title: t("features.smart.title"),
      description: t("features.smart.description"),
    },
    {
      icon: Zap,
      title: t("features.fastCharge.title"),
      description: t("features.fastCharge.description"),
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {t("features.title")}
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            {t("features.subtitle")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
                className="group"
              >
                <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-gray-100 hover:border-blue-300 hover:shadow-xl transition-all duration-300">
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
